import { generateUserAgentHeader, getTermsOfUseId, getUpdatePasswordPath, getUpdateUserMethod, getUserResourcePath, urls, } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const registerPatient = (register, osType, osVersion, app, appVersion, language, appHash) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            name: 'registerPatient',
            method: 'POST',
            url: urls.apiUrl + `v1/${getUserResourcePath(app)}`,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
                'X-Integrity-Token': appHash,
                'X-Bundle-ID': app,
            },
            data: {
                Email: register.email,
                Password: register.password,
                Country: register.country,
                FirstName: register.firstName,
                LastName: register.lastName,
                DateOfBirth: register.dateOfBirth,
                Language: language,
                GuardianFirstName: register.guardianFirstName,
                GuardianLastName: register.guardianLastName,
                Gender: register.gender,
                BirthCountry: register.birthCountry,
                BirthZipCode: register.birthZipCode,
                consents: [
                    {
                        id: getTermsOfUseId(app),
                        action: 'accept',
                    },
                    {
                        id: 'pp',
                        action: 'accept',
                    },
                ],
            },
        })
            .then(() => {
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const updatePassword = (updatePasswordData, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'PATCH',
            url: urls.apiUrl + `v1/${getUpdatePasswordPath(app)}/${updatePasswordData.userID}/password`,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                [app === 'libre1' ? 'password' : 'newPassword']: updatePasswordData.newPassword,
                secondaryAuthentication: {
                    email: updatePasswordData.emailConfirmation,
                    password: updatePasswordData.currentPassword,
                },
            },
        })
            .then(() => {
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const updatePatient = (id, patient, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: `${getUpdateUserMethod(app)}`,
            url: urls.apiUrl + `v1/${getUserResourcePath(app)}/` + id,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                FirstName: patient.firstName,
                LastName: patient.lastName,
                DateOfBirth: patient.dateOfBirth,
                GuardianFirstName: patient.guardianFirstName,
                GuardianLastName: patient.guardianLastName,
            },
        })
            .then(() => {
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const getPatient = (patientId, osType = 'none', osVersion = 'none', app = 'libre1', appVersion = 'none') => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.apiUrl + `v1/${getUserResourcePath(app)}/` + patientId,
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            name: 'getPatient',
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const resendVerificationEmail = (patientId, osType = 'none', osVersion = 'none', app = 'llu5', appVersion = 'none') => {
    return mediator.request('api:invoke', {
        method: 'POST',
        url: urls.apiUrl + `v1/${getUserResourcePath(app)}/` + patientId + '/verifications/email/resend',
        headers: {
            'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
        },
    });
};
